// @ts-nocheck
export default {
  OPEN_DIALOG: 'OPEN_DIALOG',
  CLOSE_DIALOG: 'CLOSE_DIALOG',
  OPEN_ALERT: 'OPEN_ALERT',
  CLOSE_ALERT: 'CLOSE_ALERT',
  CLOSE_ALL_DIALOGS: 'CLOSE_ALL_DIALOGS',
  CLOSE_ALL_ALERTS: 'CLOSE_ALL_ALERTS',
  OPEN_DRAWER: 'OPEN_DRAWER',
  CLOSE_DRAWER: 'CLOSE_DRAWER',
  CHANGE_DASHBOARD_PAGE_TITLE: 'CHANGE_DASHBOARD_PAGE_TITLE',
  CHANGE_DASHBOARD_PAGE_HINT: 'CHANGE_DASHBOARD_PAGE_HINT',
  CHANGE_PREFERENCES_PAGE_TITLE: 'CHANGE_PREFERENCES_PAGE_TITLE',
  ALTER_DASHBOARD_PAGE_SUBTITLE: 'ALTER_DASHBOARD_PAGE_SUBTITLE',
  SET_TOPBAR_EDIT_VIEW: 'SET_TOPBAR_EDIT_VIEW',
  SIDEBAR_EXPEND_TOGGLE: 'SIDEBAR_EXPEND_TOGGLE',
  SIDEBAR_SUBMENU_OPEN: 'SIDEBAR_SUBMENU_OPEN',
  SIDEBAR_SUBMENU_CLOSE: 'SIDEBAR_SUBMENU_CLOSE',
  SIDEBAR_SUBMENU_TOGGLE: 'SIDEBAR_SUBMENU_TOGGLE',
  SET_DASHBOARD_BACK_LINK: 'SET_DASHBOARD_BACK_LINK',
  SPLASH_START_LOADING: 'SPLASH_START_LOADING',
  SPLASH_STOP_LOADING: 'SPLASH_STOP_LOADING',
  SET_FEATURE_DASHBOARD_META: 'SET_FEATURE_DASHBOARD_META',
  ADD_AUTOFILL_REF: 'ADD_AUTOFILL_REF',
  REMOVE_AUTOFILL_REF: 'REMOVE_AUTOFILL_REF',
  RESET_AUTOFILL_REF: 'RESET_AUTOFILL_REF'
};
